import React from 'react';
import styles from './DetailSection.module.scss';

interface DetailField {
  label: string;
  value: React.ReactNode;
}

interface DetailSectionProps {
  title: string;
  fields: DetailField[];
}

export default function DetailSection({ title, fields }: DetailSectionProps) {
  return (
    <div className={styles.section}>
      <div className={styles.title}>{title}</div>
      <div className={styles.grid}>
        {fields.map((field, i) => (
          <div key={i}>
            <div className={styles.label}>{field.label}</div>
            <div className={styles.value}>{field.value || '\u2014'}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
